import * as React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ToggleColorMode from './toggleColorMode';
import { NavLink } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import '../style/menuStyle.css'
const drawerWidth = 240;

const navItems = [
    {
        name: ' الأذكار المضاعفة',
        link: 'AlathkarAlmudafa'
    },
    {
        name: 'ورد الذكر',
        link: 'werdAlthekr'
    },
    {
        name: 'أذكار الصلاة',
        link: 'athkarEsalah'
    },
    {
        name: 'أذكار النوم',
        link: 'athkarElnom'
    },

    {
        name: 'أذكار المساء',
        link: 'athkarElmasaa'
    },
    {
        name: 'أذكار الصباح',
        link: 'athkarEsabah'
    },
   
    {
        name: <HomeIcon/>,
        link: '/'
    },
  
 
 
 
];

function DrawerAppBar(props) {
    const { window } = props;
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const drawer = (
        <Box   onClick={handleDrawerToggle} sx={{ textAlign: 'center', bgcolor: "background.peper" }} >
            <Typography sx={{ my: 2 }}>
                <ToggleColorMode />
            </Typography>
            <Divider />
            <List >
                {navItems.toReversed().map((item, index) => (
                    <ListItem   key={index} disablePadding>
                        <ListItemButton  sx={{ textAlign: 'center' }}  component={NavLink} to={item.link}>
                            <ListItemText primary={item.name} />
                        </ListItemButton>
                        
                    </ListItem>
                    
                ))}
              <div className="dot"></div>
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex', bgcolor: "background.peper" }} >

            <AppBar component="nav" sx={{ color: "text.menu", backgroundColor: "background.menu" }} >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: { sm: 'none' } }}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        component="div"
                        sx={{ flexGrow: 1, display: { xs: 'none', sm: 'block' } }}
                    >
                        <ToggleColorMode />
                    </Typography>
                    <Box sx={{ display: { xs: 'none', sm: 'block', }}}>
                        {navItems.map((item, index) => (
                            <Button  className="itemsName" key={index} sx={{ color: "text.menu" }} component={NavLink} to={item.link}>
                                {item.name}
                            </Button>
                        ))}
                        
                    </Box>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box>
    );
}

DrawerAppBar.propTypes = {
    window: PropTypes.func,
};

export default DrawerAppBar;
